import { pixelsToRem } from 'MoshtixShared/helper-pixels-to-rem';
import { theme } from 'MoshtixShared/helper-theme-ticket-distro';

export const dialogStyles = {
  backgroundColor: 'white',
  padding: pixelsToRem(10),
  display: 'flex',
  flexWrap: 'wrap',
  gap: pixelsToRem(12),

  input: {
    svg: {
      fill: theme.palette.success,
      color: theme.palette.success,
    },
  },
};

export const headerCss = {
  display: 'flex',
  alignItems: 'center',
  gap: pixelsToRem(20),
  height: pixelsToRem(30),
  paddingBottom: '0',
  img: {
    height: pixelsToRem(48),
  },
  h2: {
    marginBottom: '0',
    fontSize: pixelsToRem(26),
  },
  border: 'none',
};

export const textBoxCss = {
  svg: {
    cursor: 'pointer',
    path: {
      fill: theme.palette.success,
    },
  },
};

export const shareButtonWrapperCss = {
  display: 'flex',
  justifyContent: 'center',
  button: {
    color: theme.palette.success,
  },
  'svg path': {
    fill: theme.palette.success,
  },
};

export const noteCss = {
  backgroundColor: theme.palette.lightInfo,
  border: `solid ${pixelsToRem(2)} ${theme.palette.info}`,
  borderRadius: pixelsToRem(8),
  width: '100%',
  display: 'flex',
  padding: pixelsToRem(10),
  gap: pixelsToRem(10),
  marginBottom: '0.75rem',
  'p:first-of-type': {
    fontWeight: '600',
  },
  a: {
    color: theme.palette.success,
    textDecoration: 'none',
    fontWeight: '700',
  },
};

export const noteCssIcon = {
  height: pixelsToRem(33),
  width: pixelsToRem(33),
  fill: theme.palette.info,
  color: theme.palette.info,
  flex: '1 0 auto',
};

export const termsLinkCss = {
  '&&': {
    color: '#0081FD',
    textDecoration: 'underline',
  },
};

export const assignTermsCss = {
  '&&': {
    textDecoration: 'underline',
  },
};
